export const debounce = (func, delay = 600, immediate = false) => {
	let timeout;
	return function () {
		const context = this;
		const args = arguments;
		const later = function () {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};
		const callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, delay);
		if (callNow) func.apply(context, args);
	};
};

export const IsValidIPV4 = (ipv4) => {
	const ipv4Pattern = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
	return ipv4Pattern.test(ipv4);
 };

 export const ExtractDomain = (url) => {
	try {
		if (IsValidDomain(url))
			return url

		let parsedURL = new URL(url);
		let domain = parsedURL.hostname;
		return domain;
	} catch (err) {
		if (err) {
			console.log(err)
			return ""
		}
	}
};

export const IsValidDomain = (domain) => {
	const domainPattern = /^[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
	return domainPattern.test(domain);
};

export const IsValidWildcard = (input) => {
	// *.example.com — subdomain wildcard
	const subdomainWild = /^\*\.[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
	// example.com/path/* — path wildcard
	const pathWild = /^[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}\/.*\*$/;
	return subdomainWild.test(input) || pathWild.test(input);
};

export const IsValidCIDR = (input) => {
	const cidrPattern = /^((25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(25[0-5]|2[0-4]\d|[01]?\d\d?)\/(3[0-2]|[12]?\d)$/;
	return cidrPattern.test(input);
};

export const IsUniversalWildcard = (input) => {
	return input.trim() === '*';
};

export const IsLocalhost = (input) => {
	if (!input) return false;
	const trimmed = input.trim();
	if (IsValidCIDR(trimmed)) return false;
	const localhostRegex = /^(https?:\/\/)?(localhost|127(?:\.\d{1,3}){3}|::1|\[::1\])(?::\d+)?(?:\/.*)?$/i;
	return localhostRegex.test(trimmed);
};

export const extractErrorMessage = (error, defaultMessage = "An unexpected error occurred. Please try again.") => {
	if (error?.response?.status === 401) {
		return "";
	}
	if (!error) return defaultMessage;

	let msg = "";
	if (typeof error === "string") {
		msg = error;
	} else if (error?.response?.data) {
		const data = error.response.data;
		if (typeof data === "string") {
			msg = data;
		} else if (typeof data.message === "string") {
			msg = data.message;
		} else if (typeof data.error === "string") {
			msg = data.error;
		}
	} else if (typeof error?.message === "string") {
		msg = error.message;
	}

	msg = msg.trim();
	if (!msg) return defaultMessage;

	// Sanitize raw SQL/DB or runtime errors so internal code/db details are not exposed to users
	const isDbOrCodeError = /(?:Error \d+|Duplicate entry|SQLSTATE|gorm|syntax error|constraint|foreign key|panic:|runtime error|dial tcp|connection refused)/i.test(msg);
	if (isDbOrCodeError) {
		if (/duplicate|unique|already exist/i.test(msg)) {
			return "This record already exists in your list.";
		}
		return defaultMessage;
	}

	// Grammar polish for common backend messages
	if (/^website already exist in/i.test(msg)) {
		msg = msg.replace(/already exist in/i, "already exists in");
	}

	// Ensure proper capitalization and ending period
	if (msg.length > 0) {
		msg = msg.charAt(0).toUpperCase() + msg.slice(1);
		if (!/[.!?]$/.test(msg)) {
			msg += ".";
		}
	}

	return msg;
};